// ScriptInjector.jsx
import { useEffect } from "react";

const ScriptInjector = ({ scriptSrc, onLoad=()=>{}, scriptProps={
  id: "payby-script",
}, onError=()=>{} }) => {

  useEffect(() => {

    const scriptId = scriptProps?.id || "payby-script";

    if (document.getElementById(scriptId)) {
      return;
    }

    const script = document.createElement("script");
    script.src = scriptSrc;
    script.id = scriptId;
    script.async = true;

    if(Object.keys(scriptProps).length > 0){
      Object.keys(scriptProps).forEach(key => {
        script.setAttribute(key, scriptProps[key]);
      });
    }


    script.onload = () => {
      if (typeof onLoad === "function") {
        onLoad();
      }
    };

    script.onerror = (error) => {
      console.error(`Failed to load script ${scriptSrc}`, error);
      if (typeof onError === "function") {
        onError(error);
      }
    };

    document.body.appendChild(script);

    return () => {
      // Optional: remove script when component unmounts
      script.remove();
    };
  }, [scriptSrc]);


  return null;
};

export default ScriptInjector;
